import * as React from "react"
import type { IconProps } from "../types"

const Lock = React.forwardRef<SVGSVGElement, IconProps>(
  ({ color = "currentColor", size = 24, ...props }, ref) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        fill={color}
        ref={ref}
        {...props}
      >
        <path
          fillRule="evenodd"
          d="M12 2C9.23858 2 7 4.23858 7 7V9H4V22H20V9H17V7C17 4.23858 14.7614 2 12 2ZM15 9V7C15 5.34315 13.6569 4 12 4C10.3431 4 9 5.34315 9 7V9H15ZM13 13V18H11V13H13Z"
        />
      </svg>
    )
  }
)
Lock.displayName = "Lock"

export default Lock
